var map = {
	"./malaysia.json": 1804
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1803;


//////////////////
// WEBPACK FOOTER
// ./src/components/config/locality ^\.\/.*\.json$
// module id = 1803
// module chunks = 0